// extracted by mini-css-extract-plugin
module.exports = {"activityDiv":"Activity_activityDiv__7dEb7","formDiv":"Activity_formDiv__36V0z"};